import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import styled from "styled-components";
import { redirectToSignup } from "../../utils/oauth";

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #8be0f5;
  padding: 20px;
`;

const LoadingText = styled.p`
  font-size: 1.2rem;
  color: #223126;
`;

/**
 * signup page - redirects to auth service via OAuth flow
 *
 * uses OAuth 2.0 authorization code flow with PKCE for security.
 * scopes requested: openid profile email backend:read backend:write
 *
 * if already logged in, redirects to home
 * otherwise initiates OAuth flow to auth service signup page
 */
const SignupPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { token } = useAppSelector((state) => state.auth);

  useEffect(() => {
    document.title = "NΛSOS Sign Up";
  }, []);

  useEffect(() => {
    // if already logged in, redirect to home or return URL
    if (token) {
      const returnUrl = searchParams.get("return");
      if (returnUrl) {
        window.location.href = decodeURIComponent(returnUrl);
      } else {
        navigate("/");
      }
      return;
    }

    // initiate OAuth flow with PKCE (redirects to signup page)
    // this redirects to auth service /signup with OAuth params
    redirectToSignup();
  }, [token, navigate, searchParams]);

  // show loading while redirecting
  return (
    <LoadingContainer>
      <LoadingText>Redirecting to signup...</LoadingText>
    </LoadingContainer>
  );
};

export default SignupPage;
